import { Injectable } from '@angular/core';
import { IProductBootstrapService } from '../../common/services/product-bootstrap.service';
import { TableConfigurationOverrideService } from '../../common/services/table-configuration-override.service';
import { SideBarMenuService } from '../../common/services/side-bar-menu.service';
import { getCavexMenuItems } from './cavex-menu-items';
import { DataTableColumn } from '../../common/components/data-table';
import { defaultProjectTableColumns } from '../projects/components/project-table-wrapper/project-table-definitions';
import { AdminUiSettings } from '../../common/dtos';

@Injectable({
  providedIn: 'root',
})
export class CavexBootstrapService implements IProductBootstrapService {
  constructor(
    private readonly tableConfigService: TableConfigurationOverrideService,
    private readonly sideBarMenuService: SideBarMenuService
  ) {
    // Do not initalize anything here. This service will be created regardless of product type.
  }

  initializeForProduct(settings: AdminUiSettings): void {
    this.registerMenuItems();
    this.registerTableOverrides();
  }

  registerMenuItems() {
    this.sideBarMenuService.registerMenuItems(getCavexMenuItems());
  }

  private registerTableOverrides() {
    const uniqueId: DataTableColumn = {
      headerLabel: 'Unique ID',
      propertyType: 'text',
      propertyName: 'projectUniqueCode',
    };

    this.tableConfigService.overrideAllColumnsForTable({
      uniqueTableId: 'project-table',
      allColumns: [
        defaultProjectTableColumns.title,
        uniqueId,
        defaultProjectTableColumns.category,
        defaultProjectTableColumns.organisation,
        defaultProjectTableColumns.startDate,
        defaultProjectTableColumns.status,
        defaultProjectTableColumns.actionButton,
      ],
    });
  }
}
